export type PartnerConfig = {
  src: string;
  alt: string;
  caps?: {
    mobile?: number;
    desktop?: number;
  };
  navBgColor?: string;
  textColor?: string;
};

export const PARTNERS: Record<string, PartnerConfig> = {
  thesun: {
    src: "/media/press/thesun.png",
    alt: "The Sun",
    navBgColor: "#eb1701",
    textColor: "white",
  },
  thetimes: {
    src: "/media/press/thetimes.png",
    alt: "The Times",
    navBgColor: "#000000",
    textColor: "white",
  },
  metro: {
    src: "/media/press/metro.png",
    alt: "Metro Finance",
    navBgColor: "#000000",
    textColor: "white",
  },
  thei: { src: "/media/press/thei.jpg", alt: "The i" },
  radiotimes: {
    src: "/media/press/radiotimes.png",
    alt: "Radio Times",
    navBgColor: "#000000",
    textColor: "white",
  },
  mailfinance: { src: "/media/press/mailfinance.png", alt: "Mail Finance" },
  thisismoney: {
    src: "/media/press/thisismoney_logo.png",
    alt: "This is Money",
  },
  thetelegraph: {
    src: "/media/press/thetelegraph.png",
    alt: "The Telegraph",
  },
};

export function getPartnerSubdomain(hostname: string) {
  const parts = hostname.split(".").filter(Boolean);
  return parts.length > 2 ? parts[0].toLowerCase() : "";
}

export function getPartnerForHostname(hostname: string): PartnerConfig | undefined {
  const subdomain = getPartnerSubdomain(hostname);
  return subdomain ? PARTNERS[subdomain] : undefined;
}

export function getPartnerForCurrentHostname(): PartnerConfig | undefined {
  if (typeof window === "undefined") return undefined;
  return getPartnerForHostname(window.location.hostname);
}
